import React from 'react';

/**
 * CampaignTable — Visual stat blocks for campaign performance.
 * Uses colored progress bars to show delivery and read rates at a glance.
 */
export default function CampaignTable({ data }) {
    if (!data) return null;

    const stats = [
        {
            label: 'Campaigns Sent',
            value: data.total_campaigns || 0,
            barPercent: 100,
            barColor: 'blue',
        },
        {
            label: 'Total Delivered',
            value: data.total_delivered || 0,
            barPercent: data.delivery_rate || 0,
            barColor: 'green',
        },
        {
            label: 'Delivery Rate',
            value: `${data.delivery_rate || 0}%`,
            barPercent: data.delivery_rate || 0,
            barColor: 'green',
        },
        {
            label: 'Read Rate',
            value: `${data.read_rate || 0}%`,
            barPercent: data.read_rate || 0,
            barColor: 'amber',
        },
    ];

    return (
        <div className="campaign-stats-grid">
            {stats.map((stat, i) => (
                <div className="campaign-stat" key={i}>
                    <div className="campaign-stat__value">{stat.value}</div>
                    <div className="campaign-stat__label">{stat.label}</div>
                    <div className="campaign-stat__bar">
                        <div
                            className={`campaign-stat__bar-fill ${stat.barColor}`}
                            style={{ width: `${Math.min(stat.barPercent, 100)}%` }}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}
